export const constructFullName = (
  prefix: string,
  firstName: string,
  middleName: string,
  lastName: string,
  suffix: string
): string => {
  return [prefix, firstName, middleName, lastName, suffix]
    .filter(item => !!item)
    .join(' ');
};
